module.exports = __webpack_public_path__ + "static/img/7.ad6e112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/7.png
// module id = nmNv
// module chunks = 0